import {connect} from 'react-redux';
import Header from './header';

export default connect(({
                            usersMap, issuesMap, pushIssues, account
                        }) => ({
    usersMap, issuesMap, pushIssues, account
}))(Header);


// WEBPACK FOOTER //
// ./src/components/schedule/issues/header/index.js